import { handleActions, createAction } from 'redux-actions';

export const CREATE_PROMOTION = createAction('CREATE_PROMOTION');
export const CREATE_PROMOTION_SUCCESS = createAction('CREATE_PROMOTION_SUCCESS');
export const CREATE_PROMOTION_FAIIL = createAction('CREATE_PROMOTION_FAIIL');

export const DEACTIVATE_PROMOTION = createAction('DEACTIVATE_PROMOTION');
export const DEACTIVATE_PROMOTION_SUCCESS = createAction('DEACTIVATE_PROMOTION_SUCCESS');
export const DEACTIVATE_PROMOTION_FAIL = createAction('DEACTIVATE_PROMOTION_FAIL');

export const UPDATE_PROMOTION = createAction('UPDATE_PROMOTION');
export const UPDATE_PROMOTION_SUCCESS = createAction('UPDATE_PROMOTION_SUCCESS');
export const UPDATE_PROMOTION_FAI = createAction('UPDATE_PROMOTION_FAI');

export const FETCH_PROMOTION = createAction('FETCH_PROMOTION');
export const FETCH_PROMOTION_SUCCESS = createAction('FETCH_PROMOTION_SUCCESS');
export const FETCH_PROMOTION_FAIL = createAction('FETCH_PROMOTION_FAIL');

export const FETCH_PROMOTIONS = createAction('FETCH_PROMOTIONS');
export const FETCH_PROMOTIONS_SUCCESS = createAction('FETCH_PROMOTIONS_SUCCESS');
export const FETCH_PROMOTIONS_FAIL = createAction('FETCH_PROMOTIONS_FAIL');

const initialState = {
  promotionCreated: null,
  promotionUpdated: null,
};

const promotionsReducer = handleActions(
  {
    [CREATE_PROMOTION_SUCCESS]: (state, { payload, }) => {
      return { ...state, promotionCreated: true, data: payload, };
    },
    [CREATE_PROMOTION_FAIIL]: (state, { payload, }) => {
      return { ...state, promotionCreated: false, errors: payload, };
    },
    [FETCH_PROMOTION_SUCCESS]: (state, { payload, }) => {
      return { ...state, data: payload, };
    },
    [FETCH_PROMOTIONS_SUCCESS]: (state, { payload, }) => {
      return { ...state, promotions: payload, };
    },
    [UPDATE_PROMOTION_SUCCESS]: (state, { payload, }) => {
      return { ...state, promotionUpdated: true, data: payload, };
    },
    [UPDATE_PROMOTION_FAI]: (state, { payload, }) => {
      return { ...state, promotionUpdated: false, errors: payload, };
    },
  },
  initialState
);

export default promotionsReducer;
